declare global {
    interface Window {
        _env_: any;
    }
}

export const setEnvironmentVariables = (obj: any) =>
    ((window as Window)._env_ = { ...(window as Window)._env_, ...obj });
setEnvironmentVariables({});

export const PartitionsApiUrl = () => (window as Window)._env_.PartitionsApiUrl as string;
export const ProductsApiUrl = () => (window as Window)._env_.ProductsApiUrl as string;
export const AllocationsApiUrl = () => (window as Window)._env_.AllocationsApiUrl as string;
export const IncomingStockNotificationApiUrl = () => (window as Window)._env_.IncomingStockNotificationApiUrl as string;
export const LegacyIntegrationApiUrl = () => (window as Window)._env_.LegacyIntegrationApiUrl as string;
export const VodafoneStockTransferImportApiUrl = () => (window as Window)._env_.VodafoneStockTransferImportApiUrl as string;
export const Environment = () => (window as Window)._env_.Environment as string;
export const BuildNumber = () => (window as Window)._env_.BuildNumber as string;
export const AuthDomain = () => (window as Window)._env_.AuthDomain as string;
export const AuthClientId = () => (window as Window)._env_.AuthClientId as string;
export const AuthAudience = () => (window as Window)._env_.AuthAudience as string;
export const FieldCompanyNamespace = () => (window as Window)._env_.FieldCompanyNamespace as string;
export const AppInsightKey = () => (window as Window)._env_.AppInsightKey as string;
//Note: The values for these environment variables are set in the ../.env file.
//      If you want to add a new variable, it should be added to both places.
